$(document).ready(function () {


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * teleport links
    // *
    // * @set outer parent element class: js-href-teleport-wrapper
    // * @set link (<a> tag) element class: js-href-teleport-link
    // * @set element to add the link to class: js-href-teleport
    // *
    // * This adds a link tag (<a>) to other elements within a wrapper
    // * links comes from a link. Example: add a link to h2, image etc. inside a teaser
    // *
    $(".js-href-teleport").each(function () {
        var $link = $(this).parents(".js-href-teleport-wrapper").find(".js-href-teleport-link"),
            href = $link.attr("href"),
            target = $link.attr("target") ? $link.attr("target") : '_self';

        if (href) {
            $(this).wrapInner('<a href="' + href + '" target="' + target + '"></a>');
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * parent clickable elements (excludes links inside)
    // *
    // * @set outer parent element class: js-click-item-parent
    // * @set link (<a> tag) element class: js-click-item-link
    // *
    // * This makes the whole element clickable and still
    // * makes other links inside clickable with their target
    // *
    $(".js-click-item-parent").delegate('a', 'click', function (e) {
        var target = $(this).attr("target"),
            url = $(this).attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    }).click(function () {
        var target = $(this).find("a.js-click-item-link").attr("target"),
            url = $(this).find("a.js-click-item-link").attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    });




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * animateIn
    // *
    // *
    var offset = 80; // Distance from Browserbottom & -top where the animation should start

    function fadeInElements() {
        var viewPortStart = $(window).scrollTop(),
            viewPortEnd = viewPortStart + $(window).height();


        $(".animateIn:visible").each(function () {
            var elementTop = $(this).offset().top,
                elementBottom = $(this).offset().top + $(this).outerHeight();

            if ((elementTop + offset) <= viewPortEnd && (elementBottom - offset) >= viewPortStart) {
                var delay = $(this).data("animation-delay");
                $(this).css("transition-delay", delay + "s").addClass("animateIn--active");
            } else {
                $(this).removeClass("animateIn--active");
            }
        });
    }

    $(window).scroll(function () {
        fadeInElements();
    });

    fadeInElements();


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add target blank to external links
    // *
    // *
    $('a:not([data-targetblank=ignore])').each(function () {
        if (location.hostname === this.hostname || !this.hostname.length) {
            // ... do nothing?
        } else {
            $(this).attr('target', '_blank');
        }
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navButton
    // *
    // *
    $(".js-navbutton").click(function () {
        $(this).toggleClass("active");
        $(".js-navmobile").toggleClass("active");
        $("body").toggleClass("freeze");
    });

    $(".js-navmobile ul li svg").click(function() {
        $(this).parent().closest("li").toggleClass("open").children("ul").slideToggle();
    })

    $(".js-navmobile ul li.active > div > svg").trigger("click");


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * heroSlider
    // *
    // *
    var $heroSlider = $(".js-hero-slider");

    if ($heroSlider.length) {
        $heroSlider.each(function () {
            $(this).find(".js-hero-slider-track").slick({
                fade: false,
                infinite: true,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 3500,
                speed: 1000,
                waitForAnimate: true,
                dots: true,
                pauseOnHover: false,
                appendDots: $(this).find(".js-hero-slider-dots"),
            });
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * contentSlider
    // *
    // *
    var $contentSlider = $(".js-content-slider");

    if ($contentSlider.length) {
        $contentSlider.each(function () {
            $(this).find(".js-content-slider-track").slick({
                fade: false,
                infinite: true,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 2500,
                speed: 1000,
                waitForAnimate: true,
                dots: true,
                pauseOnHover: false,
                appendDots: $(this).find(".js-content-slider-dots"),
                prevArrow: $(this).find(".js-content-slider-prev"),
                nextArrow: $(this).find(".js-content-slider-next"),
            });

            $(this).on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                var i = (currentSlide ? currentSlide : 0) + 1;
                $(this).find(".js-content-slider-count").text(i);
            });
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion
    // *
    // *
    $(".js-accordion-header").click(function () {
        $(this).parents(".js-accordion-item").toggleClass("active");
        $(this).parents(".js-accordion-item").find(".js-accordion-content").slideToggle();

        // $(this).parents(".js-accordion-item").siblings().removeClass("active").find(".js-accordion-content").slideUp();
        // $(this).siblings(".js-accordion-content").slideToggle();
    });

    // open item from url hash (e.g. back from product overview to its brand)
    var accordionHash = decodeURIComponent(window.location.hash.substring(1));

    if (accordionHash) {
        $(".js-accordion-item[data-anchor]").filter(function () {
            return $(this).attr("data-anchor") === accordionHash;
        }).addClass("active").find(".js-accordion-content").show();
    }

    // remember item in url, so the browser back button opens it again
    $(".js-accordion-item[data-anchor] .js-accordion-content a").click(function () {
        history.replaceState(null, "", "#" + $(this).parents(".js-accordion-item").attr("data-anchor"));
    });

    $(".js-accordion-showmore").click(function () {
        $(this).hide();
        $(this).parents(".js-accordion").find(".js-accordion-item").show();
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * dialog window
    // *
    // *
    var $dialog = $(".js-dialog"),
        dialogState = sessionStorage.getItem('dialogState');

    $(".js-close-dialog").click(function () {
        $dialog.addClass("close");
        sessionStorage.setItem('dialogState', true);
        $(this).parents(".js-dialog").get(0).close();
        $("body").removeClass("freeze");
    });

    // backdrop click
    $(".js-dialog").click(function (e) {
        if (e.target === e.currentTarget) {
            $dialog.addClass("close");
            sessionStorage.setItem('dialogState', true);
            $(this).get(0).close();
            $("body").removeClass("freeze");
        }
    });

    if (!dialogState && $dialog.length > 0) {
        $dialog.get(0).showModal();
        $("body").addClass("freeze");
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * dialog inquiry
    // *
    // *
    $(".js-dialoginquiry-button").click(function() {
        $("body").addClass("freeze");
        $(".js-dialoginquiry").get(0).showModal();
    })

    if($(".js-dialoginquiry").hasClass("active")) {
        $(".js-dialoginquiry").get(0).showModal();
    }
    
    $(".js-dialoginquiry-close").click(function() {
        $("body").removeClass("freeze");
        $(".js-dialoginquiry").get(0).close();
    })

    


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * header nav
    // *
    // *
    // $(".js-nav li.parent").on("mouseenter", function (e) {
    //     // e.preventDefault();
    //     $(this).addClass("active");
    // });

    // $(".js-nav li.parent").on("mouseleave", function (e) {
    //     // e.preventDefault();
    //     $(this).removeClass("active");
    // });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * carousel
    // *
    // *
    var $carousel = $(".js-carousel");

    if ($carousel.length) {
        $carousel.each(function () {
            $(this).slick({
                fade: false,
                infinite: true,
                arrows: true,
                autoplay: false,
                autoplaySpeed: 2500,
                speed: 1000,
                waitForAnimate: true,
                dots: false,
                slidesToShow: 3,
                pauseOnHover: false,
                prevArrow: $(this).siblings(".js-carousel-prev"),
                nextArrow: $(this).siblings(".js-carousel-next"),
                responsive: [
                    {
                        breakpoint: 1100,
                        settings: {
                          slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 800,
                        settings: {
                          slidesToShow: 1,
                        //   centerMode: true
                        }
                    }
                ]
            });
        });
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * sliderCard
    // *
    // *
    var $sliderCard = $(".js-slidercard");

    if ($sliderCard.length) {
        $sliderCard.each(function () {
            $(this).slick({
                fade: false,
                infinite: true,
                arrows: true,
                autoplay: false,
                autoplaySpeed: 2500,
                speed: 1000,
                waitForAnimate: true,
                dots: false,
                slidesToShow: 3,
                pauseOnHover: false,
                prevArrow: $(this).siblings(".js-slidercard-prev"),
                nextArrow: $(this).siblings(".js-slidercard-next"),
                responsive: [
                    {
                        breakpoint: 1100,
                        settings: {
                          slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 800,
                        settings: {
                          slidesToShow: 1,
                        //   centerMode: true
                        }
                    }
                ]
            });
        });
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * productSlider
    // *
    // *
    var $productSlider = $(".js-productslider");

    if ($productSlider.length) {
        $productSlider.each(function () {
            $(this).slick({
                fade: false,
                infinite: true,
                arrows: false,
                autoplay: false,
                autoplaySpeed: 2500,
                speed: 1000,
                waitForAnimate: true,
                dots: true,
                pauseOnHover: false,
                appendDots: $(".js-productslider-dots"),
            });
        });
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * mage text video
    // *
    // *
    $(".js-imagetext-video").click(function() {
        $(this).prop('controls', true);
        $(this).siblings(".js-imagetext-icon").hide();
    })




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * minicart
    // *
    // *
    $(".js-minicart-open").click(function () {
        showMiniCart();
    });

    $(".js-minicart-close").click(function () {
        hideMiniCart();
    });

    // close miniCart whenever user clicks outside minicart aside
    $(".js-minicart").on("click", function (e) {
        if ($(e.target).closest(".js-minicart-inner").length > 0) return; // Ignore click if click is inside minicart

        hideMiniCart();
    });

    function showMiniCart(showBadge = false) {
        $(".js-minicart").addClass("active");
        $(".js-minicart-badge").removeClass("active");

        if (showBadge) $(".js-minicart-badge").addClass("active");

        loadMiniCartProducts();
    }

    function hideMiniCart() {
        $(".js-minicart").removeClass("active");
        $(".js-minicart-badge").removeClass("active");
    }

    function loadMiniCartProducts() {
        $.ajax({
            url: "/assets/components/site/connector.php?action=getcart",
            type: "GET",
            data: {},
            success: function (response) {
                //console.log("Server antwortet:", response);

                // set products content
                $(".js-minicart-products").html(response.data.output);
                $(".js-minicart-total").html(response.data.total_formatted);

                if (response.data.total_quantity <= 0) {
                    $(".js-minicart, .js-header-cartnumber").addClass("empty");
                } else {
                    $(".js-minicart, .js-header-cartnumber").removeClass(
                        "empty",
                    );
                }
            },
            error: function (xhr) {
                console.error("Error:", xhr.responseText);
            },
        });
    }

    function updateMiniCartProduct(productId, quantity) {
        $.ajax({
            url: "/assets/components/site/connector.php?action=updatecartitem",
            type: "GET",
            data: { id: productId, quantity: quantity },
            success: function (response) {
                //console.log("Server antwortet:", response);

                // set data
                setHeaderCartNumber(response.data.order.total_quantity);

                // update cart
                loadMiniCartProducts();
            },
            error: function (xhr) {
                console.error("Error:", xhr.responseText);
            },
        });
    }

    // change quantity of an cart item
    $(document).on("change", ".js-minicart-quantity", function () {
        var productId = $(this).data("product"),
            quantity = $(this).val();

        updateMiniCartProduct(productId, quantity);
    });

    // change quantity of a cart item via stepper (+ / -)
    $(document).on(
        "click",
        ".js-minicart-stepper-dec, .js-minicart-stepper-inc",
        function () {
            var $btn = $(this),
                $stepper = $btn.closest(".js-minicart-stepper"),
                productId = $stepper.data("product"),
                $val = $stepper.find(".js-minicart-stepper-val"),
                currentQty = parseInt($val.text()) || 1,
                dir = $btn.hasClass("js-minicart-stepper-dec") ? -1 : 1,
                newQty = Math.max(0, currentQty + dir);

            updateMiniCartProduct(productId, newQty);
        },
    );

    // remove item from cart
    $(document).on("click", ".js-minicart-remove", function () {
        var productId = $(this).data("product");

        updateMiniCartProduct(productId, 0);
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * quantity stepper (e.g. shopTeaser, before add to cart)
    // *
    // *
    $(document).on(
        "click",
        ".js-stepper-dec, .js-stepper-inc",
        function () {
            var $btn = $(this),
                $stepper = $btn.closest(".js-stepper"),
                $val = $stepper.find(".js-stepper-val"),
                dir = $btn.hasClass("js-stepper-dec") ? -1 : 1,
                newQty = Math.max(1, (parseInt($val.val()) || 1) + dir);

            $val.val(newQty).trigger("change");
        },
    );

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add to cart
    // *
    // *
    $(".js-addtocart-form").on("submit", function (e) {
        e.preventDefault();

        let formData = new FormData(this),
            $button = $(this).find('[type="submit"]');

        $button.prop("disabled", true);

        $.ajax({
            url: "/assets/components/site/connector.php?action=addtocart",
            type: "POST",
            data: formData,
            dataType: "json",
            processData: false, // muss bei FormData auf false
            contentType: false, // darf NICHT gesetzt werden
            success: function (response) {
                //console.log("Server antwortet:", response);

                if (response.status !== "success") {
                    handleCartError(response);
                    return;
                }

                // set data
                $(".js-minicart-cartlink").attr("href", response.data.url);
                setHeaderCartNumber(response.data.total_quantity);

                // show minicart, ohne minicart (b2b) Bestaetigung am Button
                if ($(".js-minicart").length) {
                    showMiniCart(true);
                } else {
                    confirmAddToCart($button);
                }
            },
            error: function (xhr) {
                console.error("Error:", xhr.responseText);
            },
            complete: function () {
                $button.prop("disabled", false);
            },
        });
    });

    function confirmAddToCart($button) {
        if (!$button.data("label")) $button.data("label", $button.html());

        clearTimeout($button.data("timer"));
        $button
            .addClass("added")
            .html($button.data("label-added") || "✓");

        $button.data(
            "timer",
            setTimeout(function () {
                $button.removeClass("added").html($button.data("label"));
            }, 2000),
        );
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * cart page (checkout overview)
    // *
    // *
    var cartTimers = {},
        cartUpdates = {},
        cartPending = 0,
        cartQueue = $.when();

    // change quantity (stepper + / - or input)
    $(document).on("change", ".js-cart-item .js-stepper-val", function () {
        var $input = $(this),
            itemId = $input.closest(".js-cart-item").data("item"),
            quantity = Math.min(999, Math.max(1, parseInt($input.val()) || 1));

        $input.val(quantity);

        // warten, bis nicht mehr geklickt wird
        clearTimeout(cartTimers[itemId]);
        cartUpdates[itemId] = quantity;
        cartTimers[itemId] = setTimeout(function () {
            delete cartTimers[itemId];
            updateCartItem(itemId, quantity);
        }, 400);
    });

    // remove item
    $(document).on("click", ".js-cart-remove", function () {
        var itemId = $(this).closest(".js-cart-item").data("item");

        clearTimeout(cartTimers[itemId]);
        delete cartTimers[itemId];
        updateCartItem(itemId, 0);
    });

    // add sample (Gratis-Probe)
    $(document).on("click", ".js-cart-sample-add", function () {
        var sample = $(this)
            .closest(".js-cart-sample")
            .find(".js-cart-sample-select")
            .val();

        if (sample) queueCartRequest("addsample", { sample: sample });
    });

    // remove sample (one piece)
    $(document).on("click", ".js-cart-sample-remove", function () {
        var $button = $(this);

        updateCartItem(
            $button.data("item"),
            (parseInt($button.data("quantity")) || 1) - 1,
        );
    });

    // place order ("Verbindlich bestellen"): Mails senden, zur Bestaetigungsseite
    $(document).on("click", ".js-cart-order", function () {
        var $button = $(this);

        if ($button.prop("disabled")) return;
        $button.prop("disabled", true);
        $(".js-cart").addClass("loading");

        // offene Mengenaenderungen zuerst abschliessen
        $.each(cartTimers, function (itemId, timer) {
            clearTimeout(timer);
            delete cartTimers[itemId];
            updateCartItem(itemId, cartUpdates[itemId]);
        });

        cartQueue = cartQueue
            .then(function () {
                return $.ajax({
                    url: "/assets/components/site/connector.php?action=placeorder",
                    type: "POST",
                    dataType: "json",
                });
            })
            .then(function (response) {
                if (response.status === "success" && response.redirect) {
                    window.location.href = response.redirect;
                    return;
                }

                handleCartError(response);
                $button.prop("disabled", false);
                $(".js-cart").removeClass("loading");
            })
            .catch(function (xhr) {
                console.error("Error:", xhr && xhr.responseText);
                $button.prop("disabled", false);
                $(".js-cart").removeClass("loading");
            });
    });

    function updateCartItem(itemId, quantity) {
        queueCartRequest("updatecartitem", { id: itemId, quantity: quantity });
    }

    function queueCartRequest(action, data) {
        cartPending++;
        $(".js-cart").addClass("loading");

        // Requests nacheinander abarbeiten, damit keine alte Menge gewinnt
        cartQueue = cartQueue
            .then(function () {
                return $.ajax({
                    url: "/assets/components/site/connector.php?action=" + action,
                    type: "POST",
                    dataType: "json",
                    data: data,
                });
            })
            .then(function (response) {
                if (response.status !== "success") handleCartError(response);

                return loadCart();
            })
            .catch(function (xhr) {
                console.error("Error:", xhr && xhr.responseText);
            })
            .then(function () {
                cartPending--;
                if (!cartPending) $(".js-cart").removeClass("loading");
            });
    }

    function loadCart() {
        return $.ajax({
            url: "/assets/components/site/connector.php?action=getcartpage",
            type: "GET",
            dataType: "json",
        }).then(function (response) {
            if (response.status !== "success") {
                handleCartError(response);
                return;
            }

            $(".js-cart-items").html(response.data.items);
            $(".js-cart-goodies").html(response.data.goodies);
            $(".js-cart-summary").html(response.data.summary);
            $(".js-cart").toggleClass("cart--empty", response.data.empty == 1);
            setHeaderCartNumber(response.data.total_quantity);
        });
    }

    function handleCartError(response) {
        // nicht (mehr) eingeloggt: zur Login-Seite
        if (response.code === "login" && response.redirect) {
            window.location.href = response.redirect;
            return;
        }

        window.alert(response.message);
    }

    function setHeaderCartNumber(quantity) {
        quantity = parseInt(quantity) || 0;

        $(".js-header-cartnumber")
            .html(quantity)
            .attr("data-count", quantity)
            .toggleClass("empty", quantity <= 0);
    }


});



// * * * * * * * * * * * * * * * * * * * * * * * * *
// * sticky Header
// *
// *
$(window).on("load scroll", function () {
    if ($(window).scrollTop() >= 40) {
        $(".js-header").addClass("sticky");
    } else {
        $(".js-header").removeClass("sticky");
    }
});





